// src/utils/imageUrl.js
import { BASE_IMAGE_URL } from '../config/config';

export const getImageUrl = (path) =>
    path ? `${BASE_IMAGE_URL}${path}` : '';
